import { render, staticRenderFns } from "./popup-dict.vue?vue&type=template&id=2fcb8b29&scoped=true"
import script from "./popup-dict.vue?vue&type=script&lang=js"
export * from "./popup-dict.vue?vue&type=script&lang=js"
import style0 from "./popup-dict.vue?vue&type=style&index=0&id=2fcb8b29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb8b29",
  null
  
)

export default component.exports